import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { isSameAgent } from "web_myplann/Activities/Helpers/isSameAgent";
import type { TaskDetailResponse } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { useFormatUserWithType } from "web_myplann/Shared/Hooks/useFormatUserWithType";
import { dateTimeFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { TaskDescription } from "web_myplann/Tasks/Components/TaskDescription";
import { TaskStatusBadge } from "web_myplann/Tasks/Components/TaskStatusBadge";

const R = Resources.Task.Detail;

type Props = {
	task: TaskDetailResponse;
};

export const TaskBasicInfoSection: FC<Props> = ({ task }) => {
	const { t } = useResource();
	const formatUserWithType = useFormatUserWithType();

	return (
		<>
			<Typography variant="sectionLabel">{t(R.BasicInfo.title)}</Typography>
			<Stack bgcolor="background.paper">
				<Stack>
					<DetailRow
						label={t(R.BasicInfo.Name)}
						element={
							<Typography variant="bodyStrong" textAlign="right">
								{task.name}
							</Typography>
						}
					/>
					<DetailRow
						label={t(R.BasicInfo.Date)}
						value={dateTimeFormatter(task.dueDate)}
					/>
					{task.statusName && (
						<DetailRow
							label={t(Resources.Activity.Detail.BasicInfo.State)}
							element={
								<TaskStatusBadge
									name={task.statusName}
									statusId={task.statusId}
								/>
							}
						/>
					)}
					{!isSameAgent(task.author, task.assignedTo) && (
						<DetailRow
							label={t(R.BasicInfo.CreatedBy)}
							value={formatUserWithType(task.author)}
						/>
					)}
					{task.assignedTo && (
						<DetailRow
							label={t(R.BasicInfo.Solver)}
							value={formatUserWithType(task.assignedTo)}
						/>
					)}
				</Stack>
				{task.description && (
					<TaskDescription
						label={t(R.BasicInfo.Desc)}
						text={task.description}
					/>
				)}
			</Stack>
		</>
	);
};
